import axios from '../utils/axios';

class VoteService {
  constructor() {
    this.BaseUrl = '/voting';
  }

  get() {
    return axios.get(this.BaseUrl);
  }

  getComparision(brand1, brand2) {
    return axios.get(
      `${this.BaseUrl}/stats/preference?brand1=${brand1}&brand2=${brand2}`
    );
  }

  getComparedBrands(brand) {
    return axios.get(`${this.BaseUrl}/stats/compared-brands?brand=${brand}`);
  }
}

export default new VoteService();
